export default __webpack_public_path__ + "static/media/Arial.9098343c.ttf";